class LoadingbarController {

  constructor($scope,loadingbar) {
    'ngInject';
    this.loadingbar = loadingbar;
  }
}

export default LoadingbarController;



// WEBPACK FOOTER //
// ./example/app/common/loadingbar/loadingbar.controller.js